import {
	PaymentMethodDTO,
	PaymentDTO
} from 'core/api';

import { ExternalPaymentsService } from 'pos/services';
import { PaymentDTOFactory, ClosingPaymentsStatus } from '../payments-processing';

export type Status = ClosingPaymentsStatus.Status & {
	CurrentPaidAmount: number,
	CurrentTipAmount: number,
	SelectedMethod: number,
	PrintGift: boolean
};

export type ProposedAmount = {
	amount: number;
	tip: number;
};

export async function refresh(state: Status, amountToPay: number, isRefund = false): Promise<Status> {
	return { ...state, ...await ClosingPaymentsStatus.refresh(state, amountToPay, isRefund) };
}

export async function add(externalPayments: ExternalPaymentsService, state: Status, method: PaymentMethodDTO, proposedAmount: ProposedAmount, isRefund = false): Promise<Status> {

	const { amount, tip } = proposedAmount;

	const newPayment = PaymentDTOFactory.create(method, amount, tip);
	const { ErrorMessage } = await ClosingPaymentsStatus.checkNewPayment(state, state.PendingAmount, newPayment, isRefund);
	if (ErrorMessage)
		return { ...state, CurrentPaidAmount: amount, CurrentTipAmount: tip, ErrorMessage };

	const result = await externalPayments.register(newPayment);
	if (!result.ok)
		return state;

	return { ...state, ... await ClosingPaymentsStatus.add(state, newPayment, isRefund), CurrentPaidAmount: 0, CurrentTipAmount: 0 };
}

export async function remove(externalPayments: ExternalPaymentsService, state: Status, payment: PaymentDTO, isRefund = false): Promise<Status> {

	const result = await externalPayments.unregister(payment);
	if (!result.ok)
		return state;

	return { ...state, ... await ClosingPaymentsStatus.remove(state, payment, isRefund) };
}

export function completeTip(state: Status, proposal: ProposedAmount): Status {

	const pendingAmount = state.PendingAmount;

	if (proposal.tip || proposal.amount < pendingAmount)
		return { ...state, CurrentPaidAmount: proposal.amount, CurrentTipAmount: proposal.tip };

	const newTipAmount = proposal.amount - pendingAmount;
	const newIntroducedAmount = proposal.amount - newTipAmount;

	return {
		...state,
		CurrentPaidAmount: newIntroducedAmount,
		CurrentTipAmount: newTipAmount
	};
}